/* Порядок важен: более общие стили — раньше, более специфичные — позже */

@import './base.css';
@import './layout.css';
@import './components.css';
@import './players.css';
@import './player-card.css';
@import './card.css';
@import './player-detail.css';
@import './editor.css';
@import './radar.css';
@import './footer.css'; 
@import './badges.css';
@import './games.css';
@import './player-games.css';
@import './admin.css';
@import './control.css';
@import './leaderboard.css';
@import './support.css';
@import './tools.css';
@import './maps.css';
@import './mods.css';
@import './streamers.css';
@import './match.css';
@import './notifications.css';
@import './profile.css';
@import './my-stats.css';
@import './archetypes.css';
@import './engagement.css';
